export default {
    data() {
        return {
            photoSizeList: [
                { value: 0, label: '0.3MP (640x480)' },
                { value: 1, label: '0.5MP (800x600)' },
                { value: 2, label: '1.2MP (1280x960)' },
                { value: 3, label: '1.6MP (1440x1080)' },
                { value: 4, label: '2.8MP (1920x1440)' },

            ],
            selectPhotoSize: 2,
        }
    },
    computed: {
        // selectPhotoSize:{
        //     get(){
        //         return this.$store.state.photoSize;
        //     },
        //     set(val){
        //         this.$store.commit('setphotoSize',val)
        //     }
        // }
    },
    watch: {
        selectPhotoSize(val) {
            // console.log('发生改变',val)
            localStorage.setItem('takePhotoSize', JSON.stringify(val));
        }
    },
    methods: {
        changePhotoSize(value) {     
            if (value === 0) {
                this.videoWidth = 640;
                this.videoHeight = 480;
            }else if (value === 1) {
                this.videoWidth = 800;
                this.videoHeight = 600;
            } else if (value === 3)  {
                this.videoWidth = 1440;
                this.videoHeight = 1080;
            }else if (value === 4)  {
                this.videoWidth = 1920;
                this.videoHeight = 1440;            
            }else {
                this.videoWidth = 1280;
                this.videoHeight = 960;
            }
            //console.log("In changePhotoSize,selectPhotoSize:", value," this.videoWidth-videoHeight:", this.videoWidth, this.videoHeight)
        },
        videoCanPlay(e) {
            // this.videoWidth = e.target.videoWidth*2;
            // this.videoHeight = e.target.videoHeight*2;
            
            let photosize = localStorage.getItem('takePhotoSize');
            
            if (photosize) {
                this.selectPhotoSize = Number(photosize)
            } else {
                this.selectPhotoSize = 2;
                localStorage.setItem('takePhotoSize', JSON.stringify(2));
            }                   

            // if (this.selectPhotoSize === 2) {
            //     this.videoWidth = 1280;
            //     this.videoHeight = 960;
            // } else if (this.selectPhotoSize === 0) {
            //     this.videoWidth = 640;
            //     this.videoHeight = 480;
            // } else {

            //     this.videoWidth = 800;
            //     this.videoHeight = 600;
            // }

            //console.log('In videoCanPlay,selectPhotoSize:',this.selectPhotoSize, "videoWidth,videoHeight:",this.videoWidth,this.videoHeight)
            this.changePhotoSize(this.selectPhotoSize);
        },
    },
}